/* stylelint-disable */
import React, { useRef } from 'react'

import { theme } from '@acorns/web-components'
import { motion } from 'framer-motion'
import range from 'lodash/range'
import styled from 'styled-components'

import { usePotential } from '../../../PotentialContext'
import { PROJECTED_INVESTMENT_YEARS_COUNT } from '../helpers/constants'

const Container = styled(motion.div)<{ containerWidth: number }>`
  align-items: center;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 13px;
  bottom: 30px;
  color: ${theme.colors.white};
  display: flex;
  flex-direction: row;
  font-size: 12px;
  justify-content: space-between;
  left: 30px;
  margin: 10px auto 0;
  max-width: 100%;
  padding: 5px 10px 4px;
  width: 100%;

  @media (max-width: ${theme.breakpoints.md}px) {
    font-size: 9px;
  }
`

const YearLabel = styled('div')<{ isHighlighted: boolean }>`
  font-weight: ${(props) => (props.isHighlighted ? 600 : 400)};
  text-align: center;
  width: 12px;
`

const ANIMATION_SETTING = {
  animate: {
    opacity: 1,
  },
  initial: { opacity: 0 },
  transition: {
    duration: 0.7,
  },
}

export const Labels: React.FC<{
  currentAge: number
  graphWidth: number
}> = ({ currentAge, graphWidth }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const { selectedAge } = usePotential()

  const yearLabels: number[] = range(
    currentAge + 1,
    currentAge + PROJECTED_INVESTMENT_YEARS_COUNT,
    2,
  )

  return (
    <Container
      {...ANIMATION_SETTING}
      ref={containerRef}
      containerWidth={graphWidth}
    >
      {yearLabels.map((year) => {
        return (
          <YearLabel
            isHighlighted={Math.abs(year - selectedAge) < 2}
            key={year}
          >
            {year}
          </YearLabel>
        )
      })}
    </Container>
  )
}
